import axios from 'axios'
import { API_BASE_URL } from '@/config/env'

// 动态配置API基础URL
const getBaseURL = () => {
  // 使用统一的环境配置
  return API_BASE_URL
}

// 统一的API配置
export const API_CONFIG = {
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
}

// 长超时配置（用于文件上传等）
export const LONG_TIMEOUT_CONFIG = {
  ...API_CONFIG,
  timeout: 0 // 0表示不设超时限制
}

// 创建通用的axios实例
export const createApiInstance = (config = API_CONFIG) => {
  const instance = axios.create(config)
  
  // 请求拦截器 - 添加token
  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
  
  // 响应拦截器 - 统一错误处理
  instance.interceptors.response.use(
    response => {
      // 检查响应状态码，如果是错误状态码，抛出异常
      if (response.data && response.data.code && response.data.code !== 200) {
        const error = new Error(response.data.message || '请求失败')
        error.response = {
          data: response.data,
          status: response.data.code
        }
        return Promise.reject(error)
      }
      return response.data
    },
    error => {
      console.log('API错误拦截器被调用:', error.response?.data)
      
      // 处理JWT相关错误
      if (error.response?.data?.message?.includes('JWT signature does not match') ||
          error.response?.data?.message?.includes('JWT validity cannot be asserted') ||
          error.response?.data?.message?.includes('JWT') ||
          error.response?.data?.message?.includes('Token已过期')) {
        console.warn('JWT验证失败，清除登录状态并跳转到登录页')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        // 使用Element Plus的消息提示
        if (window.ElMessage) {
          window.ElMessage.error('登录已过期，请重新登录')
        }
        // 立即跳转到登录页
        window.location.href = '#/login'
        return Promise.reject(error)
      }
      
      // 只有在非登录相关接口的401错误才跳转到登录页
      if (error.response?.status === 401) {
        const currentPath = window.location.pathname
        const isAuthRequest = error.config?.url?.includes('/auth/')
        
        // 如果不是在登录页面且不是认证相关请求，才跳转到登录页
        if (!isAuthRequest && currentPath !== '/login' && currentPath !== '/') {
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          window.location.href = '#/login'
          return Promise.reject(error)
        }
      }
      
      // 直接抛出错误，让组件处理
      return Promise.reject(error)
    }
  )
  
  return instance
}

// 导出默认实例
export default createApiInstance()